import React from "react";

import CollectionSelect from "metabase/containers/CollectionSelect";

const FormCollectionWidget = ({ field }) => <CollectionSelect {...field} />;

export default FormCollectionWidget;



// WEBPACK FOOTER //
// ./components/form/widgets/FormCollectionWidget.jsx